import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Box, Button } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';

import './Header.css';

import { useAuth } from '../../auth/useAuth';
import { PolicyAPI } from '../../features/Policy/api';
import LocalStorageService from '../../services/localStorage';
import { BCBSAL_ORG_ID } from '../../shared/const';

const localStorageService = LocalStorageService.getService();

const Header: React.FC<{ isQuestionnaire: boolean }> = ({
  isQuestionnaire,
}) => {
  const { orgId } = useParams();
  const { isAuthenticated, logout } = useAuth();

  const [logo, setLogo] = React.useState<string | null>(null);

  const brandingInfo = localStorageService.getBrandingInfo();

  useEffect(() => {
    (async () => {
      if (orgId == BCBSAL_ORG_ID) {
        if (brandingInfo) {
          setLogo(JSON.parse(brandingInfo).branding);
        }
      } else {
        if (orgId) {
          try {
            const result = await PolicyAPI.getBrandingData(orgId);
            setLogo(
              result.data?.branding?.logo ? result.data.branding.logo : null
            );
          } catch (e) {
            console.error('Error fetching branding data', e);
          }
        }
      }
    })();
  }, [orgId, brandingInfo]);

  return (
    <Box component="section" className="headerBox">
      <Grid container className="container">
        {logo && (
          <Grid
            size={{ md: 3.3, sm: 6, xs: 12 }}
            style={{ borderRight: '2px solid #004E87', padding: '5px 0' }}
            className="providers-header-logo"
          >
            <img
              src={logo}
              alt="BlueCross BlueSheild"
              style={{ maxWidth: '220px' }}
            />
          </Grid>
        )}
        <Grid
          size={{ md: 8.7, sm: 6, xs: 12 }}
          className="providers-header"
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            className="providers-header-text"
            style={{ paddingLeft: logo ? '32px' : '0px' }}
          >
            {isQuestionnaire ? 'Policy Questionnaire' : 'Medical Policies'}
          </div>
          {isAuthenticated && (
            <Button
              onClick={logout}
              variant="text"
              size="small"
              sx={{ color: 'white' }}
            >
              Sign Out
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
